import { Component, Input, inject } from '@angular/core';
import { SiteTimeZoneService } from '../../../services/SiteTimeZoneService';
import { TranslationService } from '../../../services/TranslationService';
import { TextTooltipDirective } from '../../directives/TextTooltip.directive';

// Icone d'horloge : une heure venue d'un site dont le fuseau differe du lecteur.
@Component({
  selector: 'app-timezone-icon',
  standalone: true,
  imports: [TextTooltipDirective],
  template: `
    <span class="inline-flex items-center text-xs cursor-help"
      [appTextTooltip]="info" [attr.aria-label]="info" role="img" data-testid="timezone-icon">
      <svg viewBox="0 0 512 512" class="w-[1em] h-[1em]" aria-hidden="true" focusable="false">
        <circle cx="256" cy="256" r="224" fill="#FDBA74" />
        <path d="M256 128 L256 256 L368 320" fill="none" stroke="#000000" stroke-width="46"
          stroke-linecap="round" stroke-linejoin="round" />
      </svg>
    </span>
  `,
})
export class TimeZoneIconComponent {
  private readonly siteTimeZoneService = inject(SiteTimeZoneService);

  // Composant, pas service racine : l'instance RACINE de TranslationService est vide.
  private readonly translationService = inject(TranslationService);

  /** Fuseau IANA du site, deja filtre ; vide : pas d'icone. */
  @Input({ required: true }) iana!: string;

  get info(): string {
    if (!this.iana) return '';
    return this.translationService.instant('app.timezone-tooltip', {
      Zone: this.iana,
      Ecart: this.siteTimeZoneService.ecartHoraire(this.iana),
    });
  }
}
